import { Controller } from "@hotwired/stimulus";
import { post } from "@rails/request.js";

export default class extends Controller {
  static values = {
    url: String
  }

  static targets = [
    "combobox"
  ];

  addTag(event) {
    const tagId = event.detail.value;

    post(this.urlValue, {
      body: JSON.stringify({ tag_id: tagId }),
      contentType: "application/json",
      responseKind: "turbo-stream"
    });
  }

  showCombobox() {
    this.comboboxTarget.classList.remove("d-none");
  }
}
